export class Msg {
    toNumber: string;
    fromNumber: string;
    message: string;
    sid: string;
    constructor() {
    } 
}
